export default "__VITE_ASSET__B$fz4T0y__"